import React, { Component } from 'react';
import styles from './stylesheets/VerifiedUserStats.module.css';
import { RightArrow, Tick, MoreHoriz, Profile } from '../Svg/index'


export class VerifiedUserStats extends Component {

    constructor(props) {
        super(props);

    }

    addNewReferral = () => {
        alert('addNewReferral')
    }

    render() {
        return (
            <div className={styles.verifiedUserStats}>
                <div className={styles.profile}>
                    <div className={styles.profileImageToggle}>
                        <span className={styles.profileIcon}>
                            <Profile></Profile>
                        </span>
                        <span className={styles.toggleIcon}>
                            <MoreHoriz></MoreHoriz>
                        </span>
                    </div>
                    {
                        this.props.isUserRegistered ?
                            <>
                                <div className={styles.profileName}>
                                    <p>JOHN SMITH</p>
                                </div>
                                <div className={styles.verificationStatus}>
                                    <p>Status: Verified <Tick></Tick></p>
                                </div>
                            </> :
                            null
                    }
                </div>
                <div className={styles.newReferral}>
                    <a onClick={this.addNewReferral}>
                        <span className={styles.profileIcon}><Profile></Profile></span>
                        <span>NEW REFERRAL</span>
                    </a>
                </div>
            </div>
        )
    }
}

export default VerifiedUserStats

